export default __webpack_public_path__ + "static/media/fw-emma-er-White Gold.2b197416.mp4";